import React from "react";

import ReactDOM from "react-dom";

import { observer } from "mobx-react";

export default observer(function SettingsDrawer(props: {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
	customClasses?: string;
}) {
	if (!props.isOpen) {
		return null;
	}

	//removes any component from current container and applies it to document.body
	return ReactDOM.createPortal(
		<div className="drawer" onClick={props.onClose}>
			<div
				className="drawer__content"
				onClick={(e) => e.stopPropagation()}
			>
				<div className="drawer__toggle" onClick={props.onClose}></div>
				{props.children}
			</div>
		</div>,
		document.body
	);
});
